import styled from "styled-components";

export const Title = styled.p`

`;

export const SelectButton = styled.div`
    border: 1px solid black;
    border-radius: 20px;
    width: 21rem;
    padding: 7px;
    
 
    display: flex;
    justify-content: space-between;
    align-items: center;

    color: #374957 !important;

    cursor: pointer;

    &:hover {
        background-color:rgba(0,0,0,0.05);
        transition: all 0.1s;
    }

    &:active {
        background-color:rgba(0,0,0,0.1);
        transition: all 0.1s;
    }
`;

export const SelectButtonText = styled.p`
    text-overflow: ellipsis;
    overflow: hidden; 
    padding-right: 10px;
    padding-left: 10px;
    white-space: nowrap;
`;